export * from "-!../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Report.vue?vue&type=template&id=68afd788&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/pages/Purchases/Report.vue?vue&type=template&id=68afd788&scoped=true
// module id = 2400
// module chunks = 31